import { useEffect, useState } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import {
  PauseCircle,
  PlayCircle,
  SkipNext,
  SkipPrevious,
} from "@mui/icons-material";
import backSixSeconds from "../../svg/backSixSeconds.svg";
import forwardSixSeconds from "../../svg/forwardSixSeconds.svg";

export const TransportControls = ({
  hidePreviousNext,
  onJumpForward,
  onJumpBack,
  onNext,
  onPause,
  onPlay,
  onPrev,
  wavesurfer,
}) => {
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    if (!wavesurfer) return;

    const wsPlay = () => {
      if (!playing) setPlaying(true);
    };

    const wsPause = () => {
      if (playing) setPlaying(false);
    };
    wavesurfer.on("play", wsPlay);
    wavesurfer.on("pause", wsPause);
    return () => {
      wavesurfer.un("play", wsPlay);
      wavesurfer.un("pause", wsPause);
    };
  }, [playing, wavesurfer]);

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      {!hidePreviousNext && (
        <Tooltip title="Previous">
          <IconButton
            aria-label="skip previous"
            color="primary"
            onClick={() => onPrev && onPrev()}
            size="small"
          >
            <SkipPrevious />
          </IconButton>
        </Tooltip>
      )}
      {!hidePreviousNext && (
        <Tooltip title="Back six seconds">
          <IconButton
            aria-label="back six seconds"
            onClick={() => onJumpBack && onJumpBack()}
            size="small"
          >
            <img
              src={backSixSeconds}
              height={24}
              width={24}
              alt="back six seconds"
            />
          </IconButton>
        </Tooltip>
      )}
      {!playing && (
        <Tooltip title="Play">
          <IconButton
            aria-label="play"
            color="primary"
            onClick={() => onPlay && onPlay()}
            size="small"
            sx={{ p: 0 }}
          >
            <PlayCircle sx={{ fontSize: 50 }} />
          </IconButton>
        </Tooltip>
      )}
      {playing && (
        <Tooltip title="Pause">
          <IconButton
            aria-label="pause"
            color="primary"
            onClick={() => onPause && onPause()}
            size="small"
            sx={{ p: 0 }}
          >
            <PauseCircle sx={{ fontSize: 50 }} />
          </IconButton>
        </Tooltip>
      )}
      {!hidePreviousNext && (
        <Tooltip title="Forward six seconds">
          <IconButton
            aria-label="forward six seconds"
            onClick={() => onNext && onJumpForward()}
            size="small"
          >
            <img
              src={forwardSixSeconds}
              height={24}
              width={24}
              alt="forward six seconds"
            />
          </IconButton>
        </Tooltip>
      )}
      {!hidePreviousNext && (
        <Tooltip title="Next">
          <IconButton
            aria-label="skip next"
            color="primary"
            onClick={() => onNext && onNext()}
            size="small"
          >
            <SkipNext />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};
